import React from 'react';
export const Mail = ({ title, ...rest }) => (
  <svg viewBox="0 0 30 21" {...rest}>
    {title && <title>{title}</title>}
    <path
      d="M26.918 0H3.082C1.38.002.002 1.331 0 2.971v15.058c.002 1.64 1.38 2.969 3.082 2.971h23.836c1.701-.002 3.08-1.331 3.082-2.971V2.972C29.998 1.332 28.62.002 26.918 0zm-7.517 11.06l9.184-8.852c.12.238.184.499.185.764v15.057a1.71 1.71 0 0 1-.202.795L19.4 11.06zm7.517-9.871c.275.002.546.063.793.18l-9.605 9.258a.574.574 0 0 0-.08.058c-.013.013-.016.03-.026.044l-3 2.891L2.289 1.368c.247-.116.518-.177.793-.178h23.836v-.001zM1.43 18.815a1.71 1.71 0 0 1-.198-.786V2.972a1.71 1.71 0 0 1 .185-.764l9.18 8.85-9.167 7.757zm1.651.995c-.264 0-.525-.056-.765-.164l9.154-7.748L15 15.301l3.526-3.4 9.148 7.748a1.89 1.89 0 0 1-.756.16H3.082v.001z"
      fill="#FFF"
    />
  </svg>
);
